<lib-filters-component [filters_options]="filter_service.filtersType"></lib-filters-component>
<h2>{{ wCupName | transloco }}</h2>

<div class="wcup-panel-container">
  <div
    *ngIf="insights"
    class="insight-wcup"
  >
    <app-olympic-insight-container
      [number]="insights.appearances"
      [title]="eventTypeData | async"
      [subtitle]="'Appearances' | transloco"
    ></app-olympic-insight-container>
    <app-olympic-insight-container
      [number]="insights.podiums"
      [title]="eventTypeData | async"
      [subtitle]="'Podiums' | transloco"
    ></app-olympic-insight-container>
    <app-olympic-insight-container
      [number]="insights.wins"
      [title]="eventTypeData | async"
      [subtitle]="'Wins' | transloco"
    ></app-olympic-insight-container>
  </div>
  <app-wa-table
    [isSortableFunc]="sortClass"
    [showCondition]="true"
    [headers]="headers"
    [isDataLoading]="false"
    [areMoreData]="areMoreData()"
    (loadMore)="loadMore()"
    [data]="dataWithPagination"
    (headerClick)="changeSort($event)"
  >
    <ng-template
      [extraClass]="['wa-table__cell--fit-right']"
      app-column
      let-detail
    >
      <div
        style="margin-left:10px"
        class
      >
        {{ detail.Year }}
      </div>
    </ng-template>
    <ng-template
      [extraClass]="['wa-table__cell--fit-left']"
      app-column
      let-detail
    >
      <a
        appCompetitionLink
        [size]="100"
        [competitionId]="detail?.StageData?.ID"
      >
        {{ detail.Place }}, {{ detail.StageData?.CountryName }}
      </a>
    </ng-template>
    <ng-template
      [extraClass]="['wa-table__cell--fit-left']"
      app-column
      let-detail
    >
      <div>{{ detail.Event }}</div>
    </ng-template>
    <ng-template
      [extraClass]="['wa-table__cell--fit-right']"
      app-column
      let-detail
    >
      <ng-container>
        <div *ngIf="detail.Results.Rnk > 3">{{ detail.Results.Outcome }}</div>
        <ng-container *ngIf="detail.Results.Rnk < 4">
          <div
            *ngIf="detail.Results.Rnk === 1"
            class="position medal-gold"
          ></div>
          <div
            *ngIf="detail.Results.Rnk === 2"
            class="position medal-silver"
          ></div>
          <div
            *ngIf="detail.Results.Rnk === 3"
            class="position medal-bronze"
          ></div>
        </ng-container>
      </ng-container>
    </ng-template>
    <ng-template
      [extraClass]="[]"
      app-column-responsive
      let-detail
    >
      <div>
        <div>
          <div class="uppertext-no-viewport">Year</div>
          <div>{{ detail.Year }}</div>
        </div>
      </div>
    </ng-template>
    <ng-template
      [extraClass]="[]"
      app-column-responsive
      let-detail
    >
      <div>
        <div>
          <div class="uppertext-no-viewport">Location</div>
          <a
            appCompetitionLink
            [size]="100"
            [competitionId]="detail?.StageData?.ID"
          >
            {{ detail.Place }}
          </a>
        </div>
      </div>
    </ng-template>
    <ng-template
      [extraClass]="[]"
      app-column-responsive
      let-detail
    >
      <div>
        <div>
          <div class="uppertext-no-viewport">Event</div>
          {{ detail.Event }}
        </div>
      </div>
    </ng-template>
    <ng-template
      [extraClass]="[]"
      app-column-responsive
      let-detail
    >
      <div>
        <div *ngIf="detail.Results.Rnk > 3">
          <div class="uppertext-no-viewport">Result</div>
          {{ detail.Results.Outcome }}
        </div>

        <ng-container *ngIf="detail.Results.Rnk < 4">
          <div class="uppertext-no-viewport">Result</div>
          <div
            *ngIf="detail.Results.Rnk === 1"
            class="position medal-gold"
          ></div>
          <div
            *ngIf="detail.Results.Rnk === 2"
            class="position medal-silver"
          ></div>
          <div
            *ngIf="detail.Results.Rnk === 3"
            class="position medal-bronze"
          ></div>
        </ng-container>
      </div>
    </ng-template>
  </app-wa-table>
</div>
